module.exports = __webpack_public_path__ + "img/0.3d5a3957.png";